
define('jst!tooltips/_list',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% if (data && data.length > 0) { %>\n  <ol class="tooltip-list">\n  <% _.each(data, function(elm){\n    print(content_tag(\'li\', {html: elm}));\n  }) %>\n  </ol>\n<% } %>\n');
 });

